import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

export interface HierarchicalCallReasonData {
  parent_reason: string;
  child_reason: string;
  call_count: number;
  resolution_rate: number;
  satisfaction_rate: number;
  pain_points_rate: number;
  avg_duration: number;
  performance_rate: number;
  reiteration_rate: number;
}

interface UseHierarchicalCallReasonsParams {
  projectId: number | null;
  startDate?: Date | null;
  endDate?: Date | null;
  enabled?: boolean;
}

export const useHierarchicalCallReasons = ({
  projectId,
  startDate,
  endDate,
  enabled = true,
}: UseHierarchicalCallReasonsParams) => {
  return useQuery({
    queryKey: ['hierarchical-call-reasons', projectId, startDate, endDate],
    queryFn: async () => {
      if (!projectId) {
        throw new Error('Project ID is required');
      }

      const { data, error } = await supabase.rpc('get_hierarchical_call_reasons', {
        p_project_id: projectId,
        p_start_date: startDate?.toISOString() || null,
        p_end_date: endDate?.toISOString() || null,
      });

      if (error) {
        console.error('Error fetching hierarchical call reasons:', error);
        throw error;
      }

      return (data || []) as HierarchicalCallReasonData[];
    },
    enabled: !!projectId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
